import { createSelector } from "reselect";
import * as api from "@/api/role";

const prefix = "admin/role/details";

const FETCH_START = `${prefix}/FETCH_START`;
const FETCH_FAIL = `${prefix}/FETCH_FAIL`;
const FETCH_SUCCESS = `${prefix}/FETCH_SUCCESS`;

const UPDATE_START = `${prefix}/UPDATE_START`;
const UPDATE_FAIL = `${prefix}/UPDATE_FAIL`;
const UPDATE_SUCCESS = `${prefix}/UPDATE_SUCCESS`;

const INSERT_START = `${prefix}/INSERT_START`;
const INSERT_SUCCESS = `${prefix}/INSERT_SUCCESS`;
const INSERT_FAIL = `${prefix}/INSERT_FAIL`;

const fetchStart = (_id) => ({ type: FETCH_START });
const fetchSuccess = (data) => ({ type: FETCH_SUCCESS, payload: data });
const fetchFail = (err) => ({ type: FETCH_FAIL, error: true, payload: err });

const updateStart = (_query) => ({ type: UPDATE_START });
const updateSuccess = (data) => ({ type: UPDATE_SUCCESS, payload: data });
const updateFail = (err) => ({ type: UPDATE_FAIL, error: true, payload: err });

const insertStart = () => ({ type: INSERT_START });
const insertSuccess = (record) => ({ type: INSERT_SUCCESS, payload: record });
const insertFail = (err) => ({ type: INSERT_FAIL, payload: err, error: true });

const baseSelector = (state) => state.role.details;

export const getIsFetching = createSelector(baseSelector, (state) => state.isFetching);

export const getRecord = createSelector(baseSelector, (state) => state.record);

export const getError = createSelector(baseSelector, (state) => state.error);

export const getHasError = createSelector(baseSelector, (state) => !!state.error);

export function fetchRecord(id) {
  return async (dispatch) => {
    dispatch(fetchStart(id));

    try {
      const data = await api.fetchRecord(id);
      dispatch(fetchSuccess(data));
    } catch (err) {
      dispatch(fetchFail(err));
    }
  };
}

export function insertRecord(record) {
  return async (dispatch) => {
    dispatch(insertStart());

    try {
      const data = await insertRecord(record);
      dispatch(insertSuccess(data));
    } catch (err) {
      dispatch(insertFail(err));
    }
  };
}

export function updateRecord(record) {
  return async (dispatch) => {
    dispatch(updateStart(record));

    try {
      const data = await api.updateRecord(record.id, record);
      dispatch(updateSuccess(data));
    } catch (err) {
      dispatch(updateFail(err));
    }
  };
}

const initialState = {
  record: null,
  error: false,
  isFetching: false,
  updated: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        record: null,
        isFetching: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        record: action.payload,
        isFetching: false,
        error: null,
      };

    case FETCH_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    case UPDATE_SUCCESS:
      return {
        ...state,
        record: action.payload,
        error: null,
      };

    case UPDATE_START:
      return {
        ...state,
        error: null,
      };

    case UPDATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
}
